const toPositiveInteger = (value, fallback) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : fallback;
};

const toWholeDays = (value, unit, fallback) => {
  const parsed = toPositiveInteger(value, fallback);
  return unit === "days" ? parsed : Math.max(1, Math.ceil(parsed / 24));
};

export const normalizeNoReplyPreferences = value => {
  const current = value || {};
  const hasMaximum = current.maxDeadlineValue !== null &&
    current.maxDeadlineValue !== undefined && current.maxDeadlineValue !== "";
  const sortOrder = current.sortOrder === "ASC" ? "ASC" : "DESC";

  if (!hasMaximum) {
    return {
      ...current,
      // A visao padrao do R25 e sempre o universo completo em atraso.
      deadlineValue: 1,
      deadlineUnit: "days",
      maxDeadlineValue: null,
      maxDeadlineUnit: null,
      sortOrder
    };
  }

  const startDay = toWholeDays(current.deadlineValue, current.deadlineUnit, 1);
  const rawMaximumDay = toWholeDays(
    current.maxDeadlineValue,
    current.maxDeadlineUnit,
    startDay + 1
  );
  const exclusiveMaximumDay = Math.max(startDay + 1, rawMaximumDay);

  return {
    ...current,
    deadlineValue: startDay,
    deadlineUnit: "days",
    // O backend usa limite superior exclusivo. A interface exibe fim inclusivo.
    maxDeadlineValue: exclusiveMaximumDay,
    maxDeadlineUnit: "days",
    sortOrder
  };
};

export const buildAllNoReplyPreferences = value => normalizeNoReplyPreferences({
  ...(value || {}),
  deadlineValue: 1,
  deadlineUnit: "days",
  maxDeadlineValue: null,
  maxDeadlineUnit: null
});

export const buildCustomNoReplyPreferences = (value, startDay, inclusiveEndDay) => {
  const start = toPositiveInteger(startDay, 1);
  const end = toPositiveInteger(inclusiveEndDay, start);
  return normalizeNoReplyPreferences({
    ...(value || {}),
    deadlineValue: start,
    deadlineUnit: "days",
    // Ex.: 1 a 3 dias na tela => [1, 4) dias no backend.
    maxDeadlineValue: end + 1,
    maxDeadlineUnit: "days"
  });
};

export const getInclusiveNoReplyEndDay = value => {
  const normalized = normalizeNoReplyPreferences(value);
  return normalized.maxDeadlineValue === null
    ? null
    : Number(normalized.maxDeadlineValue) - 1;
};

export const formatNoReplyPeriod = value => {
  const normalized = normalizeNoReplyPreferences(value);
  if (normalized.maxDeadlineValue === null) {
    return "todos em atraso - 1 dia ou mais";
  }
  const start = Number(normalized.deadlineValue);
  const end = getInclusiveNoReplyEndDay(normalized);
  return `periodo de ${start} a ${end} ${end === 1 ? "dia" : "dias"}`;
};

export const formatNoReplySort = value => value === "ASC"
  ? "maior tempo sem resposta primeiro"
  : "menor tempo sem resposta primeiro";
